import {gsap} from "gsap";
import {initTitleAnimation} from "../components/titleAnimation";


export function initAboutUsPageLanding() {
    const tabletWidth = 1000;

    function initAboutUsParallax() {
        const parallaxSection = $('.parallax').parents('.section');
        const parallaxImage = $('.parallax .parallax-image');
        const percents = {
            minus: '-30%',
            plus: '25%',
        }

        if ($(window).width() < tabletWidth) {
            percents.minus = '-10%'
            percents.plus = '10%';
        }

        gsap.timeline({
            scrollTrigger: {
                trigger: parallaxSection,
                scrub: true,
                invalidateOnResize: true,
            },
        }).fromTo(parallaxImage, {
            y: percents.minus,
            willChange: 'transform',
        }, {
            y: percents.plus,
            willChange: 'auto'
        });
    }




    initAboutUsParallax();
    initTitleAnimation();
}
